module.exports = function() {
  return {
    $get: ['$timeout', '$ionicScrollDelegate', function($timeout, $ionicScrollDelegate) {
      function scrollToTop(contentName) {
        $timeout(function() {
          let num
          $ionicScrollDelegate.$getByHandle(contentName)._instances.some(function(elem, index) {
            if (elem.$$delegateHandle == contentName) {
              num = index
              return true
            };
            return false
          })
          $ionicScrollDelegate.$getByHandle(contentName)._instances[num].scrollTop(false)
        }, 0)
      }
      function stop(evt) {
        evt.stopPropagation()
        evt.preventDefault()
      }
      return {
        scrollToTop,
        stop
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/uiHelper.js